<template>
  <div id="app">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Material+Icons">
      <Navbar />
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar'

import JsonExcel from 'vue-json-excel'

export default {
  name: 'App',
  components: {
      Navbar
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
}

input:focus, textarea:focus, select:focus{
    border-bottom: 1px solid #03a9f4 !important;
    -webkit-box-shadow: 0 1px 0 0 #03a9f4 !important;
    box-shadow: 0 1px 0 0 #03a9f4 !important;
}

select:focus {
    outline: 1px solid #b3e5fc;
}

</style>
